import { UpdateCurrentUserGenderScreenNavigationProps } from "./types"
import React from "react"
import UpdateCurrentUserGender from "./update-current-user-gender-screen"
import { PageRoot } from "~screens/page-root"


const UpateContactScreen: React.FC<UpdateCurrentUserGenderScreenNavigationProps> = () => {
  return (
    <PageRoot>
      <UpdateCurrentUserGender />
    </PageRoot>
  )
}

export default UpateContactScreen
